const getDo = (locale: string) => {
    switch (locale) {
        case "hu":
            return "dó";
        case "et":
            return "jo";
        default:
            return "do";
    }
};

export default getDo;
